import * as React from 'react';

import {classify} from 'src/utils/index';
import urlParse from 'url-parse';
import {useEnvironmentContext} from 'src/hooks/useEnvironmentContext';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {getValidNextPath} from 'src/utils/security';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {InContextAlert} from '@spaced-out/ui-design-system/lib/components/InContextAlert';

import type {ssoLoginProps} from 'src/types/authentication';

import css from './sso.css';


const SSOLogin = (props: ssoLoginProps) => {
  const {t} = useLabelTranslation();
  const {ssoAuthUrl, showDualAuthForm = false} = props;
  const {isExtension} = useEnvironmentContext();
  // @ts-expect-error - TS2769 - No overload matches this call.
  const query = urlParse(window.location, true).query;
  const nextPathname = query.nextPathname || '';
  const nextSearch = query.nextSearch || '';
  const parsedNextSearch = new URLSearchParams(nextSearch);
  const queryString = parsedNextSearch.toString();
  const validNextPath = getValidNextPath(nextPathname);
  const rawHash = window.location.hash || '';

  const fullPath = `${validNextPath}${rawHash}?${queryString}`;

  const pathString = JSON.stringify({path: fullPath});

  return (
    <div className={css.loginWrapper}>
      <div
        className={classify(css.contentWrapper, {
          [css.wideContent]: showDualAuthForm,
        })}
      >
        <a
          href={`${ssoAuthUrl}&state=${encodeURIComponent(pathString)}`}
          target="_blank"
          rel="noopener noreferrer"
          className={css.loginLink}
        >
          <Button
            size={isExtension ? 'small' : 'medium'}
            type={showDualAuthForm ? 'secondary' : 'primary'}
            classNames={{wrapper: css.signInBtn}}
          >
            {t('Login_with_SSO', 'Login with SSO')}
          </Button>
        </a>
        {query.oauth_error && (
          <InContextAlert
            semantic="danger"
            classNames={{wrapper: css.ssoError}}
          >
            {t(
              'Your_account_is_not_setup_for_SSO_contact_your_SSO_administrator',
              'Your account is not setup for SSO, contact your SSO administrator.',
            )}
          </InContextAlert>
        )}
      </div>
    </div>
  );
};

export default SSOLogin;
